import { gql, useLazyQuery } from "@apollo/client";
import { useCallback } from "react";
import { PopulatedDesignBoard } from "../../__generated__/types";

const GET_MOOD_BOARDS = gql`
  query GetDesignBoards($designerId: ID!) {
    getDesignBoards(designerId: $designerId) {
      _id
      color
      description
      designerId
      finish
      greatFor
      images {
        _id
        name
        path
        url
        title
        credit
        description
      }
      name
      pattern
      roomType
      texture
      type
      why
      displayOrder
      featuredOnBio
      published
    }
  }
`;

export const useGetMoodBoardsQuery = () => {
  const [getMoodBoardsQuery, { loading, data }] = useLazyQuery(GET_MOOD_BOARDS);

  const getMoodBoards = useCallback(
    async (designerId: string, refresh: boolean = false) => {
      const result = await getMoodBoardsQuery({
        variables: {
          designerId,
        },
        fetchPolicy: refresh ? "network-only" : "cache-first",
      });
      return result?.data?.getDesignBoards;
    },
    [getMoodBoardsQuery]
  );

  const moodBoards = data?.getDesignBoards as PopulatedDesignBoard[];

  return {
    getMoodBoards,
    loading,
    moodBoards,
  };
};
